import { Classes } from "@blueprintjs/core";
import styled, { css } from "styled-components";

export const AppliedLabelsWrapper = styled.div<{
  $minimal?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-width: 0;

  .${Classes.POPOVER_TARGET} {
    display: flex;
  }

  ${({ $minimal }) =>
    $minimal &&
    css`
      gap: 1px;
    `}
`;

export const CollapsedAppliedLabelsWrapper = styled(AppliedLabelsWrapper)`
  gap: 3px;
`;
